import Vue from 'vue'

var util = {
    resource (options) {
        if (!options.data) {
            options.data = {}
        }
        if (!options.method) {
            options.method = 'get'
        }
        if (options.method == 'get') {
            options.data = {
                params: options.data
            }
        }
        Vue.http[options.method](options.url, options.data).then((res) => {
            return res.json()
        }).then((res) => {
            // if (res.code == 401) {}
            options.success(res)
        })
    },
    // 微信分享
    getWx : function() {
        var _this = this;
        var data = {
            url : location.href,
            csrfmiddlewaretoken: $('.login-container input').val()
        };
        $.ajax({
            url : '/api/website/signature/weixin/',
            type : 'post',
            data : data,
            success : function(res) {
                _this.callBack(res.data);
            }
        });
    },
    // 微信回调函数
    callBack : function (data) {
      var wxurl = location.href;
      var wxtitle = "【视频合集】2017小饭桌全球青年创业者大会演讲视频回顾，一起探讨未来！";
      var wxdes = "精剪版演讲嘉宾视频，要看从速！";
      var wximg = "http://static-image.xfz.cn/share_logo.png";

      wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.app_id, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.noncestr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名
          jsApiList: [
              'onMenuShareTimeline',
              'onMenuShareAppMessage'
          ]
      });
      wx.ready(function(){
          wx.onMenuShareTimeline({
              title: wxtitle, // 分享标题
              link: wxurl, // 分享链接
              imgUrl: wximg, // 分享图标
              desc: wxdes,
              success: function () {
                  // 用户确认分享后执行的回调函数
              },
              cancel: function () {
                  // 用户取消分享后执行的回调函数
              }
          });
          wx.onMenuShareAppMessage({
              title: wxtitle, // 分享标题
              link: wxurl, // 分享链接
              imgUrl: wximg, // 分享图标
              desc: wxdes,
              type: '', // 分享类型,music、video或link，不填默认为link
              dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function () {
                  // 用户确认分享后执行的回调函数
              },
              cancel: function () {
                  // 用户取消分享后执行的回调函数
              }
          });
      });
    }
}
export default util



// WEBPACK FOOTER //
// ./src/assets/js/util.js